import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Attach token from localStorage as Bearer (fallback alongside httpOnly cookie)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("hoshizora_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    // Inject active brand for authenticated endpoints that honour `brand`
    const brand = localStorage.getItem("hoshizora_active_brand");
    const url = (config.url || "").split("?")[0];
    const brandAware = (
        url === "/products" || url === "/categories"
    );
    if (brand && brandAware && !config.params?.brand) {
        config.params = { ...(config.params || {}), brand };
    }
    return config;
});

export default api;

export function formatIDR(value) {
    if (value === null || value === undefined || value === "") return "Rp 0";
    try {
        return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            maximumFractionDigits: 0,
        }).format(Number(value));
    } catch {
        return `Rp ${value}`;
    }
}

export function fileUrl(path) {
    if (!path) return "";
    if (/^https?:\/\//i.test(path)) return path;
    const token = localStorage.getItem("hoshizora_token") || "";
    return `${API}/files/${path}?auth=${encodeURIComponent(token)}`;
}

// Public (unauthenticated) image URL — used on public catalog routes
export function publicFileUrl(path) {
    if (!path) return "";
    if (/^https?:\/\//i.test(path)) return path;
    return `${API}/files/${path}`;
}

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
